import enums from './enums'

export default {

    MONTHS: [
        "Januari", "Februari", "Maret",
        "April", "Mei", "Juni",
        "Juli", "Agustus", "September",
        "Oktober", "November", "Desember"
    ],

    MONTHS_SHORT: [
        "Jan", "Feb", "Mar", "Apr",
        "Mei", "Jun", "Jul", "Agu",
        "Sep", "Okt", "Nov", "Des"
    ],

    workTypeLabel(workType) {
        const types = enums.SpkWorkType
        const labels = {
            [types.REPAIR]: "Repair",
            [types.QC]: "QC",
            [types.DISMANTLE]: "Dismantle",
            [types.ASSEMBLY]: "Assembly"
        }
        return labels[workType] || "Repair"
    },

    getBasePagedQuery(page, size) {
        let string = "?page="+page+"&size="+size
        return string
    },

    parseDate(date, useShortMonth = false) {

        if(this.isBlank(date) || date == "null") { return "-" }

        const month_names = [
            "Januari", "Februari", "Maret",
            "April", "Mei", "Juni",
            "Juli", "Agustus", "September",
            "Oktober", "November", "Desember"
        ]

        let year = date.slice(0, 4)
        let month = date.slice(5, 7)
        let day = date.slice(8, 10)
        let dayInt = parseInt(day, 10)
        let monthInt = parseInt(month, 10)

        let monthString = useShortMonth ? this.MONTHS_SHORT[monthInt - 1] : this.MONTHS[monthInt - 1]

        return `${dayInt} ${monthString} ${year}`

    },

    parseHourMinute(date) {

        if(date) {
            return date.slice(11, 16)
        }

        return '-'

    },

    setFlash(msg) {
        localStorage.setItem('flash', msg)
    },

    getFlash() {
        let flash = localStorage.getItem('flash')
        localStorage.removeItem('flash')
        return flash
    },

    toastSuccess(vue, msg, toastTitle='Sukses') {
        vue.$bvToast.toast(msg, {
            title: toastTitle,
            autoHideDelay: 5000,
            appendToast: true,
            variant: 'success'
        })
    },

    toastError(vue, msg, toastTitle='Gagal') {
        vue.$bvToast.toast(msg, {
            title: toastTitle,
            autoHideDelay: 5000,
            appendToast: true,
            variant: 'danger'
        })
    },

    parseError(vue, error, toastTitle = "Gagal") {

        console.log(error)

        if(error.response.status == 401) {
            return
        }

        let message = ""

        if(error.response && error.response.data.reason != null) {
            message = error.response.data.reason
        }
        else if(error.message.startsWith("timeout")) {
            message = "Gagal menghubungi server, periksa jaringan anda dan coba kembali! [ERR-TIMEOUT]"
        }
        else {
            message = error.message
        }

        this.toastError(vue, message, toastTitle)

    },

    isBlank(input) {
        return input == null || input == ''
    },

    printPayload(payload) {

        for(var pair of payload.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

    },

    getRoleId() {
        return Number(localStorage.getItem("roleId"))
    },

    getWilayahId() {
        return Number(localStorage.getItem("wilayahId"))
    }

}
